if (!customElements.get('mm-audio-player')) {
  customElements.define('mm-audio-player', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const audio = this.querySelector('audio');
      if (!audio) return;
      const panel = this.querySelector('.mma-player');
      const play = this.querySelector('.mma-play');
      const seek = this.querySelector('input[type=range]');
      const rewind = this.querySelector('.mma-rewind');
      const speed = this.querySelector('select');
      const status = this.querySelector('.mma-status');
      const initialStatus = status.textContent;
      const elapsed = this.querySelector('[data-elapsed]');
      const duration = this.querySelector('[data-duration]');
      const time = n => Number.isFinite(n) ? Math.floor(n / 60) + ':' + String(Math.floor(n % 60)).padStart(2, '0') : '–:––';
      const state = () => {
        play.setAttribute('aria-pressed', String(!audio.paused));
        play.setAttribute('aria-label', (audio.paused ? this.dataset.play : this.dataset.pause) + ': ' + this.dataset.title);
      };
      const update = () => {
        elapsed.textContent = time(audio.currentTime);
        duration.textContent = time(audio.duration);
        if (Number.isFinite(audio.duration) && audio.duration > 0) {
          seek.disabled = false;
          rewind.disabled = false;
          seek.max = audio.duration;
          seek.value = audio.currentTime;
          seek.setAttribute('aria-valuetext', time(audio.currentTime) + ' / ' + time(audio.duration));
        }
      };
      play.addEventListener('click', async () => {
        if (!audio.paused) { audio.pause(); return; }
        document.querySelectorAll('mm-audio-player audio').forEach(other => { if (other !== audio) other.pause(); });
        status.textContent = this.dataset.loading;
        try { await audio.play(); status.textContent = initialStatus; }
        catch (error) { if (error.name !== 'AbortError') status.textContent = this.dataset.error; state(); }
      });
      audio.addEventListener('play', () => {
        document.querySelectorAll('mm-audio-player audio').forEach(other => { if (other !== audio) other.pause(); });
        state();
      });
      audio.addEventListener('pause', state);
      audio.addEventListener('ended', () => { state(); update(); });
      audio.addEventListener('loadedmetadata', update);
      audio.addEventListener('durationchange', update);
      audio.addEventListener('timeupdate', update);
      audio.addEventListener('error', () => { status.textContent = this.dataset.error; state(); });
      seek.addEventListener('input', () => { if (Number.isFinite(audio.duration)) audio.currentTime = Number(seek.value); });
      rewind.addEventListener('click', () => { audio.currentTime = Math.max(0, audio.currentTime - 10); });
      speed.addEventListener('change', () => { audio.playbackRate = Number(speed.value); });
      panel.hidden = false;
      audio.hidden = true;
      play.disabled = false;
      speed.disabled = false;
      update();
    }
    disconnectedCallback() { this.querySelector('audio')?.pause(); }
  });
}
